
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import * as prismic from '@prismicio/client';
import { GetStaticPropsContext, GetStaticPropsResult, NextPage } from 'next';
import { DEFAULT_DOMAIN, LOCALES, LOCALES_MAP, PRISMIC_CUSTOM_TYPES } from 'prismic/config';
import { client } from 'prismic/helpers/fetchContent';
import { DonateForm } from 'components/organisms/DonateForm';
import { DonateFormProps } from 'components/organisms/DonateForm/DonateForm.types';

const { footer, page } = PRISMIC_CUSTOM_TYPES;

const Donate: NextPage<DonateFormProps> = ({ footer }) => {
  return <DonateForm footer={footer} />;
};

type PageParams = {
  domain?: string | Array<string>;
  slug?: string | Array<string>;
};

interface DonateProps {
  footer: any;
}

 async function _getServerSideProps({
  locale: localePrefix,
  params: { domain = DEFAULT_DOMAIN } = {},
}: GetStaticPropsContext<PageParams>): Promise<GetStaticPropsResult<DonateProps>> {
  const currentDomain =
    (domain && (typeof domain === 'string' ? domain : domain[0])) || 'ballenberg.ch';

  const locale =
    (localePrefix && (typeof localePrefix === 'string' ? localePrefix : localePrefix[0])) ??
    LOCALES.default;

  const lang = LOCALES_MAP[locale];

  // Get Header and footer
  const [footerData] = await Promise.all([
    client.getFirst({
      lang,
      predicates: [
        prismic.predicate.at('document.tags', [currentDomain]),
        prismic.predicate.at('document.type', footer),
      ],
    }),
  ]);

  const fetchedFooter = {
    footer: footerData,
    domain: currentDomain,
    type: page,
  };

  return {
    props: {
      ...fetchedFooter,
    },
  };
}

export default Donate;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/donate/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  